




































import Vue from 'vue';
import { Toast } from '@descomplica/vue-components';
import LandingHeader from '@/components/LandingHeader.vue';
import BottomButton from '@/components/BottomButton.vue';
import ConfirmationCodeForm from '@/components/forms/ConfirmationCodeForm.vue';
import VIEWS_NAMES from '@/router/viewsNames';
import i18n from '@/i18n';
import { allowedRoutesGuard } from '@/helpers/guards';
import { UserInfo } from '@/store/modules/user/state';
import { AnalyticsActions } from '@/store/modules/analytics/actions';
import Analytics from '@/helpers/analytics/analytics';
import { Course } from '@/store/modules/course/state';
import { Campus } from '@/store/modules/location/state';
import pipeline from '@/pipeline';
import steps from '@/pipeline/steps';

export default Vue.extend({
  components: {
    LandingHeader,
    ConfirmationCodeForm,
    BottomButton,
    Toast,
  },
  beforeRouteEnter: allowedRoutesGuard(
    [VIEWS_NAMES.SIGN_IN, VIEWS_NAMES.SIGN_UP, VIEWS_NAMES.CHANGE_PHONE],
    VIEWS_NAMES.SIGN_IN,
  ),
  data() {
    return {
      code: '',
      error: '',
      disabled: false,
      showToast: false,
    };
  },
  computed: {
    isConfirmButtonEnabled(): boolean {
      return Boolean(this.code) && !this.error;
    },
    isLoginSuccess(): string {
      return this.$store.getters.isLoginSuccess;
    },
    user(): UserInfo {
      return this.$store.getters.user;
    },
    selectedChannel(): string {
      return this.$store.getters.selectedChannel;
    },
    confirmationCodeSubtitle(): string {
      let templateName = 'default';
      let templateParams: any = { phone: this.user.phone, email: this.user.email };

      if (this.selectedChannel !== 'emailAndPhone') {
        templateName = 'singleChannel';
        templateParams = {
          channel: this.loginChannel,
          value: this.selectedChannel === 'email' ? this.user.email : this.user.phone,
        };
      }

      return i18n.t(`confirmationCodeSubtitle.${templateName}`, templateParams);
    },
    loginChannel(): string {
      const channelNameMapping: { [key: string]: string } = {
        phone: i18n.t('mobilePhone'),
        email: i18n.t('email'),
        emailAndPhone: i18n.t('emailAndPhone'),
      };

      return channelNameMapping[this.selectedChannel].toLowerCase();
    },
  },
  methods: {
    async confirmCodeHandler() {
      this.disabled = true;

      await this.$store.dispatch('VALIDATE_LOGIN_CODE', { code: this.code });

      if (this.isLoginSuccess) {
        await this.$store
          .dispatch('PULL_CURRENT_ADMISSION')
          .catch(async () => await this.firstAccess());

        await this.$store.dispatch('PULL_PIPELINE');
        await this.$store.dispatch('START_PIPELINE');
      } else {
        this.disabled = false;
        this.error = i18n.t('wrongCodeMessage');
      }
    },
    clearHandler() {
      this.code = '';
      this.error = '';
    },
    doneHandler(code: string) {
      this.code = code;
    },
    async sendNewCodeHandler(selectedChannel?: string) {
      const previousNotificationChannel = this.$store.getters.selectedChannel;

      this.$store.dispatch(AnalyticsActions.REQUEST_NEW_SIGN_IN_CODE, {
        selectedChannel,
        previousNotificationChannel,
      });
      await this.$store.dispatch('SEND_LOGIN_CODE', { selectedChannel });

      this.showToast = true;

      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
    async changePhone() {
      this.disabled = true;

      await this.$store.dispatch('VALIDATE_LOGIN_CODE', { code: this.code });

      if (this.isLoginSuccess) {
        this.$router.push({ name: VIEWS_NAMES.CHANGE_PHONE });
      } else {
        this.disabled = false;
        this.error = i18n.t('wrongCodeMessage');
      }
    },
    async firstAccess() {
      await this.$store.dispatch('CREATE_NEW_ADMISSION');
      Analytics.trackFirstAccess();
    },
  },
});
